import { marketPlace } from '@/axios'

export default {
  createWithdraw (payload) {
    return marketPlace().post('merchant/wallet/withdraw', payload)
  }
}
